import type {WorkMetadata} from 'services/metadata/types';

export const isWorkMetadataValue = (value: unknown): value is WorkMetadata =>
  typeof value === 'object' && !!(value as WorkMetadata).work;
